import React from "react";
export var ListContext = React.createContext({});
//# sourceMappingURL=ListContext.js.map